export default class Invoicing {
    constructor(client) {
        this.client = client
    }

    async getSalesInvoices(provider, page) {
        return await this.request(
            "GET",
            `invoices/${provider}/sales`,
            {
                params: {
                    page: page || 1
                }
            }
        )
    }

    async acceptPurchaseInvoice(provider, id, comment) {
        return await this.request('POST', `invoices/${provider}/purchase/acceptReject/${id}`, {
            data: {
                accepted: true,
                comment: comment
            }
        })
    }

    async request(method, endpoint, params) {
        return await this.client.request({
            method: method,
            url: "/karadjordje/" + endpoint,
            ...params
        })
    } 
}